import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "bg-light mb-2 mt-3 py-1 px-2 shadow-sm rounded" };
const _hoisted_2 = { class: "ml-3" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_4 = {
    key: 0,
    class: "text-muted"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PrincipalMenu = _resolveComponent("PrincipalMenu");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("b", null, "Olá, " + _toDisplayString(_ctx.user.name) + "!", 1),
            _hoisted_3,
            (_ctx.canShowSaldoLiberado)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createTextVNode("Saldo Liberado: "),
                    _createElementVNode("b", null, _toDisplayString(_ctx.saldoLiberado), 1),
                    _createTextVNode(".")
                ]))
                : _createCommentVNode("", true)
        ]),
        _createVNode(_component_PrincipalMenu, { menus: _ctx.menus }, null, 8, ["menus"])
    ]));
}
